import { IconType } from "../../components/Icon";
import { Layout } from "../../components/Layout";
import { Navbar } from "../../components/Navbar";
import { NavigationTitle } from "../../components/NavigationTitle";
import { ChangePassword } from "../../components/PagesContent/ChangePassword";
import { Icons } from "../../utils";

export const ChangePasswordPage = () => {
  const topBar = (
    <NavigationTitle
      title="changePassword"
      iconName={Icons.arrowLeft}
      iconType={IconType.default}
    />
  );
  const navBar = <Navbar />;

  return (
    <Layout topBar={topBar} navBar={navBar} includeGaps={false} fixedTop={false}>
      <ChangePassword />
    </Layout>
  );
};
